export default "__VITE_ASSET__BdQK1T3A__"